(function () {
  const bootstrap = window.__VAT_CUSTOMER_BOOTSTRAP || {};
  const storageKey = 'uk_vat_customer_segment';
  const segments = bootstrap.segments || {};
  const strings = bootstrap.strings || {};
  const validSegments = ['private', 'business'];
  const kundengruppeOptionName = bootstrap.kundengruppeOptionName || 'Kundengruppe';
  const segmentMatchers = bootstrap.segmentMatchers || {
    private: '0% MwSt',
    business: '19% MwSt'
  };
  const segmentCustomerMatchers = bootstrap.segmentCustomerMatchers || {
    private: ['Privatkunde'],
    business: ['Firmenkunde']
  };

  function normalizeSegment(segment) {
    return validSegments.includes(segment) ? segment : bootstrap.defaultSegment || 'business';
  }

  function getStoredSegment() {
    try {
      return normalizeSegment(window.localStorage.getItem(storageKey));
    } catch (error) {
      return normalizeSegment(null);
    }
  }

  function hasStoredSegment() {
    try {
      return validSegments.includes(window.localStorage.getItem(storageKey));
    } catch (error) {
      return false;
    }
  }

  function persistSegment(segment) {
    try {
      window.localStorage.setItem(storageKey, normalizeSegment(segment));
    } catch (error) {
      return;
    }
  }

  function getSegment() {
    return getStoredSegment();
  }

  function getSegmentMatcher(segment) {
    const seg = normalizeSegment(segment);
    return String(segmentMatchers[seg] || '').trim();
  }

  function getSegmentTag(segment) {
    return getSegmentMatcher(segment);
  }

  function getVariantOptionValue(variant, optionIndex) {
    if (!variant) return '';
    if (optionIndex === 0) return variant.option1 || '';
    if (optionIndex === 1) return variant.option2 || '';
    if (optionIndex === 2) return variant.option3 || '';
    return '';
  }

  function findKundengruppeOptionIndex(options) {
    const opts = options || [];
    for (let i = 0; i < opts.length; i += 1) {
      const name = typeof opts[i] === 'string' ? opts[i] : opts[i]?.name;
      if (name === kundengruppeOptionName) return i;
    }
    return -1;
  }

  function valueMatchesSegment(value, segment) {
    const matcher = getSegmentMatcher(segment);
    if (!matcher) return false;
    return String(value || '').includes(matcher);
  }

  function valueMatchesCustomerSegment(value, segment) {
    const needles = segmentCustomerMatchers[normalizeSegment(segment)] || [];
    const haystack = String(value || '');
    return needles.some((needle) => haystack.includes(needle));
  }

  function isAlways19Product(productData) {
    const variants = productData?.variants || [];
    const options = productData?.options || [];
    const kgIdx = findKundengruppeOptionIndex(options);
    if (kgIdx < 0 || !variants.length) return false;

    let hasPrivateRate = false;
    let hasBusinessRate = false;
    let hasCustomerSegment = false;
    let hasTaxMarker = false;

    variants.forEach((variant) => {
      const kgValue = getVariantOptionValue(variant, kgIdx);
      if (valueMatchesSegment(kgValue, 'private')) {
        hasPrivateRate = true;
        hasTaxMarker = true;
      }
      if (valueMatchesSegment(kgValue, 'business')) {
        hasBusinessRate = true;
        hasTaxMarker = true;
      }
      if (valueMatchesCustomerSegment(kgValue, 'private') || valueMatchesCustomerSegment(kgValue, 'business')) {
        hasCustomerSegment = true;
      }
    });

    if (hasPrivateRate) return false;
    if (hasBusinessRate) return true;
    return hasCustomerSegment && !hasTaxMarker;
  }

  function getAlways19HintText(short) {
    if (short) {
      return strings.vatHintAlways19Short || strings.vatHintBusinessShort || strings.vatHintAlways19 || '';
    }
    return strings.vatHintAlways19 || strings.vatHintBusiness || '';
  }

  function kundengruppeValueMatchesSegment(value, segment) {
    const normalized = normalizeSegment(segment);
    const kgValue = String(value || '');

    if (!kgValue) return true;

    const hasTaxMarker = valueMatchesSegment(kgValue, 'private') || valueMatchesSegment(kgValue, 'business');
    if (!hasTaxMarker && valueMatchesCustomerSegment(kgValue, normalized)) {
      return true;
    }

    if (valueMatchesSegment(kgValue, 'business') && !valueMatchesSegment(kgValue, 'private')) {
      return valueMatchesCustomerSegment(kgValue, normalized);
    }

    return valueMatchesSegment(kgValue, normalized);
  }

  function getVariantKundengruppeValue(variant, options) {
    const idx = findKundengruppeOptionIndex(options);
    if (idx < 0) return '';
    return getVariantOptionValue(variant, idx);
  }

  function segmentFromKundengruppeValue(value) {
    const kgValue = String(value || '');
    if (!kgValue) return null;

    const matchesPrivateCustomer = valueMatchesCustomerSegment(kgValue, 'private');
    const matchesBusinessCustomer = valueMatchesCustomerSegment(kgValue, 'business');

    if (matchesPrivateCustomer && !matchesBusinessCustomer) return 'private';
    if (matchesBusinessCustomer && !matchesPrivateCustomer) return 'business';
    if (matchesPrivateCustomer) return 'private';
    if (matchesBusinessCustomer) return 'business';
    if (valueMatchesSegment(kgValue, 'private')) return 'private';
    if (valueMatchesSegment(kgValue, 'business')) return 'business';
    return null;
  }

  function variantMatchesSegment(kundengruppeValue, segment) {
    return kundengruppeValueMatchesSegment(kundengruppeValue, segment);
  }

  function resolveVariantForProduct(productData, segment) {
    const variants = productData?.variants || [];
    const options = productData?.options || [];
    if (!variants.length) return null;

    const kgIdx = findKundengruppeOptionIndex(options);
    if (kgIdx < 0) {
      return variants.find((variant) => variant.available) || variants[0];
    }

    const normalized = normalizeSegment(segment);
    const always19 = isAlways19Product(productData);

    const matched = variants.find((variant) => {
      const kgValue = getVariantOptionValue(variant, kgIdx);
      if (always19) {
        return valueMatchesCustomerSegment(kgValue, normalized);
      }
      return valueMatchesSegment(kgValue, normalized);
    });

    if (matched) return matched;

    if (always19) {
      return variants.find((variant) => valueMatchesSegment(getVariantOptionValue(variant, kgIdx), 'business')) ||
        variants.find((variant) => variant.available) ||
        variants[0];
    }

    return null;
  }

  function parseProductCardData(card) {
    try {
      const raw = card.dataset.productVariants || '{}';
      return JSON.parse(raw);
    } catch (error) {
      return { variants: [], options: [] };
    }
  }

  function formatMoney(cents) {
    const amount = Number(cents || 0);
    if (typeof window.Shopify !== 'undefined' && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(amount, bootstrap.moneyFormat || '${{amount}}');
    }

    const value = amount / 100;
    const currency = window.Shopify?.currency?.active || 'EUR';
    const locale = document.documentElement.lang || 'de-DE';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency
      }).format(value);
    } catch (error) {
      return `${value.toFixed(2)} ${currency}`;
    }
  }

  function isPrivateSegment(segment) {
    return normalizeSegment(segment) === 'private';
  }

  function track(eventName, props) {
    try {
      if (window.posthog && typeof window.posthog.capture === 'function') {
        window.posthog.capture(eventName, props || {});
      }
    } catch (error) {
      // Tracking darf den Kaufprozess nie stoeren.
    }
  }

  function cartRoute() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  // Serialisiert die Attribut-POSTs, damit bei schnellen Segment-Toggles
  // immer der zuletzt gewaehlte Wert als letzter beim Server ankommt.
  let attributeSyncChain = Promise.resolve();

  function syncCartCustomerTypeAttribute(segment) {
    const normalizedSegment = normalizeSegment(segment);
    attributeSyncChain = attributeSyncChain.then(() =>
      fetch(`${cartRoute()}/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { customer_type: normalizedSegment } })
      }).catch(() => null)
    );
    return attributeSyncChain;
  }

  async function fetchCartState() {
    const response = await fetch(`${cartRoute()}.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart fetch failed');
    return response.json();
  }

  function fetchProductData(handle, cache) {
    if (cache[handle]) return cache[handle];
    const promise = fetch(`/products/${handle}.js`, { headers: { Accept: 'application/json' } })
      .then((response) => (response.ok ? response.json() : null))
      .catch(() => null);
    cache[handle] = promise;
    return promise;
  }

  async function requestLineChange(payload) {
    const response = await fetch(`${cartRoute()}/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    });
    if (!response.ok) throw new Error('Cart change failed');
    return response.json();
  }

  async function requestCartUpdate(updates) {
    const response = await fetch(`${cartRoute()}/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates })
    });
    if (!response.ok) throw new Error('Cart update failed');
    return response.json();
  }

  function buildRebookedProperties(item, segment) {
    const properties = Object.assign({}, item.properties || {});
    properties._vat_segment = normalizeSegment(segment);
    if (properties._vat_tags != null && properties._vat_tags !== '') {
      properties._vat_tags = getSegmentMatcher(segment);
    }
    return properties;
  }

  let rebookInProgress = false;
  let pendingRebookSegment = null;

  function lineHasMeaningfulProperties(item) {
    const props = item.properties || {};
    return Object.keys(props).some((key) => key !== '_vat_segment' && props[key] != null && props[key] !== '');
  }

  // Bucht pro Aufruf hoechstens EINE Zeile um und liest den Warenkorb direkt
  // davor frisch — so arbeiten wir nie auf veralteten Keys/Mengen, wenn der
  // Kunde parallel Mengen aendert oder Zeilen entfernt.
  // Rueckgabe: true, wenn eine Zeile angefasst wurde (weiterer Durchlauf noetig).
  async function runRebookPass(segment, productCache, skippedKeys, result) {
    const cart = await fetchCartState();
    const items = Array.isArray(cart.items) ? cart.items : [];

    for (const item of items) {
      if (skippedKeys.has(item.key)) continue;

      const productData = item.handle ? await fetchProductData(item.handle, productCache) : null;
      if (!productData) {
        if (item.handle) {
          skippedKeys.add(item.key);
          result.failed += 1;
        }
        continue;
      }

      if (findKundengruppeOptionIndex(productData.options || []) < 0) continue;

      const target = resolveVariantForProduct(productData, segment);
      if (!target) continue;

      if (target.id === item.variant_id) {
        const lineSegment = item.properties && item.properties._vat_segment;
        if (!lineSegment || lineSegment === segment) continue;
        try {
          await requestLineChange({
            id: item.key,
            quantity: item.quantity,
            properties: buildRebookedProperties(item, segment)
          });
          result.changed += 1;
        } catch (error) {
          skippedKeys.add(item.key);
          result.failed += 1;
        }
        return true;
      }

      if (!target.available) {
        skippedKeys.add(item.key);
        result.failed += 1;
        continue;
      }

      // Ein einzelner /cart/update.js-Request setzt die alte Zeile auf 0 und
      // die Ziel-Variante auf die Summenmenge — atomar, damit eine
      // Unterbrechung (Reload/Navigation) weder Duplikate noch verlorene
      // Positionen hinterlassen kann.
      const targetQty = items
        .filter((other) => other.variant_id === target.id)
        .reduce((sum, other) => sum + (Number(other.quantity) || 0), 0) + (Number(item.quantity) || 0);

      const updates = {};
      updates[item.key] = 0;
      updates[String(target.id)] = targetQty;

      try {
        await requestCartUpdate(updates);
        result.changed += 1;

        if (lineHasMeaningfulProperties(item)) {
          try {
            const freshCart = await fetchCartState();
            const targetLine = (freshCart.items || []).find((line) => line.variant_id === target.id);
            if (targetLine) {
              await requestLineChange({
                id: targetLine.key,
                quantity: targetLine.quantity,
                properties: buildRebookedProperties(item, segment)
              });
            }
          } catch (error) {
            // Properties sind Dokumentation, keine Steuerlogik — Fehler hier
            // duerfen die Umbuchung nicht scheitern lassen.
          }
        }
      } catch (error) {
        skippedKeys.add(item.key);
        result.failed += 1;
      }
      return true;
    }

    return false;
  }

  async function rebookCartToSegment(segment) {
    // Ein waehrend der Umbuchung erneut gewechseltes Segment wird nicht
    // verworfen, sondern vom laufenden Runner uebernommen.
    pendingRebookSegment = normalizeSegment(segment);
    if (rebookInProgress) return null;
    rebookInProgress = true;

    const result = { changed: 0, failed: 0 };
    const productCache = {};

    try {
      let guard = 0;
      while (pendingRebookSegment !== null && guard < 60) {
        const activeSegment = pendingRebookSegment;
        const skippedKeys = new Set();

        while (pendingRebookSegment === activeSegment && guard < 60) {
          guard += 1;
          const touchedLine = await runRebookPass(activeSegment, productCache, skippedKeys, result);
          if (!touchedLine) {
            if (pendingRebookSegment === activeSegment) {
              pendingRebookSegment = null;
            }
            break;
          }
        }
      }

      if (result.changed > 0 || result.failed > 0) {
        track('vat_cart_rebooked', {
          segment: getSegment(),
          lines_changed: result.changed,
          lines_failed: result.failed
        });
      }

      if (result.changed > 0) {
        if (document.querySelector('[data-cart-form]')) {
          // Cart-Seite ist serverseitig gerendert: nur reloaden, ohne vorher
          // cart:updated zu feuern — sonst wuerde der Reload andere Skripte
          // (z.B. pallet-bundling) mitten in ihrer Reaktion abbrechen.
          window.location.reload();
        } else {
          const updatedCart = await fetchCartState();
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: updatedCart } }));
        }
      }
    } catch (error) {
      track('vat_cart_rebook_failed', {
        segment: getSegment(),
        message: String((error && error.message) || error)
      });
    } finally {
      rebookInProgress = false;
      pendingRebookSegment = null;
    }

    return result;
  }

  function getKundengruppeValueForSegment(segment) {
    const catalog = parseSolarCatalog();
    if (catalog?.products?.length) {
      for (const product of catalog.products) {
        const variant = resolveVariantForProduct(product, segment);
        if (!variant) continue;
        const value = getVariantKundengruppeValue(variant, product.options || []);
        if (value) return value;
      }
    }

    const matcher = getSegmentMatcher(segment);
    if (!matcher) return '';
    return normalizeSegment(segment) === 'private'
      ? `Privatkunde (${matcher})`
      : `Firmenkunde (${matcher})`;
  }

  function updateFormSegments(segment) {
    document.querySelectorAll('[data-vat-line-segment]').forEach((input) => {
      input.value = normalizeSegment(segment);
    });
  }

  function updateSwitches(segment) {
    const normalizedSegment = normalizeSegment(segment);

    document.querySelectorAll('[data-vat-switch]').forEach((switchElement) => {
      switchElement.hidden = false;

      switchElement.querySelectorAll('[data-vat-segment-option]').forEach((button) => {
        const isActive = button.dataset.vatSegmentOption === normalizedSegment;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      const status = switchElement.querySelector('[data-vat-switch-status]');
      if (status) {
        const label = segments[normalizedSegment]?.label || normalizedSegment;
        status.textContent = (strings.switchStatus || 'Auswahl: {{ segment }}').replace('{{ segment }}', label);
      }
    });
  }

  function updateCardTaxHint(card, variant, options, productData) {
    const hint = card.querySelector('[data-card-vat-hint]');
    if (!hint) return;

    const kgValue = getVariantKundengruppeValue(variant, options);
    if (!kgValue) {
      hint.hidden = true;
      hint.textContent = '';
      return;
    }

    if (isAlways19Product(productData)) {
      hint.hidden = false;
      hint.textContent = getAlways19HintText(true);
      hint.dataset.vatTaxType = 'business';
      return;
    }

    if (valueMatchesSegment(kgValue, 'private')) {
      hint.hidden = false;
      hint.textContent = strings.vatHintPrivateShort || strings.vatHintPrivate || '';
      hint.dataset.vatTaxType = 'private';
    } else if (valueMatchesSegment(kgValue, 'business')) {
      hint.hidden = false;
      hint.textContent = strings.vatHintBusinessShort || strings.vatHintBusiness || '';
      hint.dataset.vatTaxType = 'business';
    } else {
      hint.hidden = true;
    }
  }

  function updateCardStock(card, variant) {
    const stockEl = card.querySelector('[data-card-stock]');
    if (!stockEl || !variant) return;

    const available = Boolean(variant.available);
    stockEl.classList.remove('stock-badge--in-stock', 'stock-badge--out-of-stock');
    stockEl.classList.add(available ? 'stock-badge--in-stock' : 'stock-badge--out-of-stock');

    const textEl = stockEl.querySelector('.stock-badge__text');
    if (textEl) {
      textEl.textContent = available
        ? (strings.inStock || 'Auf Lager')
        : (strings.outOfStock || 'Ausverkauft');
    }
  }

  function updateProductCard(card, segment) {
    const productData = parseProductCardData(card);
    const variant = resolveVariantForProduct(productData, segment);
    if (!variant) return;

    const variantInput = card.querySelector('[data-card-variant-id]');
    if (variantInput) {
      variantInput.value = variant.id;
    }

    const priceEl = card.querySelector('[data-card-price]');
    if (priceEl) {
      priceEl.textContent = formatMoney(variant.price);
      priceEl.classList.toggle('product-card__price--sale', Number(variant.compare_at_price) > Number(variant.price));
    }

    const compareEl = card.querySelector('[data-card-compare-price]');
    if (compareEl) {
      const onSale = Number(variant.compare_at_price) > Number(variant.price);
      compareEl.classList.toggle('product-card__price--compare-empty', !onSale);
      compareEl.setAttribute('aria-hidden', onSale ? 'false' : 'true');
      compareEl.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
    }

    updateCardStock(card, variant);
    updateCardTaxHint(card, variant, productData.options, productData);

    const submitBtn = card.querySelector('[data-add-to-cart]');
    const actionsWrap = card.querySelector('.product-card__actions');
    const soldOut = !variant.available;

    card.classList.toggle('product-card--sold-out', soldOut);

    if (submitBtn) {
      submitBtn.dataset.soldOut = soldOut ? 'true' : 'false';
      if (soldOut) {
        submitBtn.disabled = true;
        submitBtn.textContent = strings.soldOut || 'Ausverkauft';
      } else {
        submitBtn.disabled = false;
        submitBtn.textContent = strings.addToCart || 'In den Warenkorb';
      }
    }

    if (actionsWrap) {
      actionsWrap.hidden = false;
    }
  }

  function updateProductCards(segment) {
    document.querySelectorAll('[data-product-card]').forEach((card) => {
      updateProductCard(card, segment);
    });
  }

  function parseSolarCatalog() {
    const node = document.querySelector('[data-solar-product-catalog]');
    if (!node) return null;

    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      return null;
    }
  }

  function buildProductCatalogForSegment(segment) {
    const catalog = parseSolarCatalog();
    if (!catalog?.products?.length) return [];

    return catalog.products.map((product) => {
      const variant = resolveVariantForProduct(product, segment);
      if (!variant) return null;

      return {
        handle: product.handle,
        title: product.title,
        variantId: variant.id,
        price: variant.price,
        available: Boolean(variant.available),
        sku: variant.sku || ''
      };
    }).filter(Boolean);
  }

  function getVatContextPayload() {
    const segment = getSegment();

    return {
      segment,
      kundengruppe: getKundengruppeValueForSegment(segment),
      tag: getSegmentMatcher(segment),
      locked: false,
      products: buildProductCatalogForSegment(segment)
    };
  }

  let mismatchTracked = false;

  function updateCartWarnings(segment) {
    const normalizedSegment = normalizeSegment(segment);

    document.querySelectorAll('[data-vat-cart-warning]').forEach((warning) => {
      const scope = warning.closest('[data-vat-cart-warning-scope]') || document;
      const items = scope.querySelectorAll('[data-cart-item]');
      const hasMismatch = Array.from(items).some((item) => {
        const kgValue = item.dataset.variantKundengruppe || '';
        const lineSegment = item.dataset.vatLineSegment || '';
        if (lineSegment) {
          return lineSegment !== normalizedSegment;
        }
        return kgValue && !variantMatchesSegment(kgValue, normalizedSegment);
      });
      warning.hidden = !hasMismatch;

      if (hasMismatch && !mismatchTracked) {
        mismatchTracked = true;
        track('vat_cart_mismatch_shown', { segment: normalizedSegment });
      }
    });
  }

  function highlightCartLineMismatch(segment) {
    const normalizedSegment = normalizeSegment(segment != null ? segment : getSegment());

    document.querySelectorAll('[data-cart-item]').forEach((lineEl) => {
      const kgValue = lineEl.dataset.variantKundengruppe || '';
      const lineSegment = lineEl.dataset.vatLineSegment || '';

      if (!kgValue && !lineSegment) {
        lineEl.classList.remove('vat-cart-line-mismatch');
        return;
      }

      let matches = true;
      if (lineSegment) {
        matches = lineSegment === normalizedSegment;
      } else if (kgValue) {
        matches = variantMatchesSegment(kgValue, normalizedSegment);
      }

      lineEl.classList.toggle('vat-cart-line-mismatch', !matches);
    });
  }

  function applySegment(segment) {
    const normalizedSegment = normalizeSegment(segment);
    const previousSegment = document.documentElement.dataset.vatSegment;
    const segmentChanged = previousSegment !== normalizedSegment;

    document.documentElement.dataset.vatSegment = normalizedSegment;
    updateFormSegments(normalizedSegment);
    updateSwitches(normalizedSegment);
    updateProductCards(normalizedSegment);
    updateCartWarnings(normalizedSegment);
    highlightCartLineMismatch(normalizedSegment);

    if (!segmentChanged) return;

    document.dispatchEvent(new CustomEvent('vat:segment-change', {
      detail: {
        segment: normalizedSegment,
        matcher: getSegmentMatcher(normalizedSegment),
        kundengruppe: getKundengruppeValueForSegment(normalizedSegment),
        products: buildProductCatalogForSegment(normalizedSegment)
      }
    }));
  }

  function setSegment(segment, options) {
    const opts = options || {};
    const normalizedSegment = normalizeSegment(segment);
    const previousSegment = document.documentElement.dataset.vatSegment || getSegment();
    const segmentChanged = previousSegment !== normalizedSegment;

    persistSegment(normalizedSegment);
    applySegment(normalizedSegment);
    syncCartCustomerTypeAttribute(normalizedSegment);

    if (segmentChanged) {
      track('vat_segment_changed', {
        segment: normalizedSegment,
        previous_segment: previousSegment,
        source: opts.source || 'unknown'
      });
    }

    // forceRebook: die Erstwahl im Modal muss auch dann umbuchen, wenn sie dem
    // Default entspricht — der Warenkorb kann aus einer frueheren Session oder
    // dem Konfigurator bereits gegenteilige Positionen enthalten.
    if ((segmentChanged || opts.forceRebook) && !opts.skipRebook) {
      rebookCartToSegment(normalizedSegment);
    }
  }

  function adoptSegment(segment, options) {
    setSegment(segment, Object.assign({ skipRebook: true, source: 'adopt' }, options || {}));
  }

  function buildModalContent(onSelect) {
    const panel = document.createElement('div');
    panel.className = 'vat-modal__panel';

    const title = document.createElement('h2');
    title.id = 'VatCustomerModalTitle';
    title.className = 'vat-modal__title';
    title.textContent = strings.modalTitle || 'Wie kaufen Sie ein?';

    const text = document.createElement('p');
    text.className = 'vat-modal__text';
    text.textContent = strings.modalText || 'Waehlen Sie aus, ob Sie privat oder als Firma einkaufen.';

    const actions = document.createElement('div');
    actions.className = 'vat-modal__actions';

    const privateButton = document.createElement('button');
    privateButton.type = 'button';
    privateButton.className = 'btn btn--secondary vat-modal__button';
    privateButton.textContent = strings.privateButton || 'Privat';
    privateButton.addEventListener('click', () => onSelect('private'));

    const businessButton = document.createElement('button');
    businessButton.type = 'button';
    businessButton.className = 'btn btn--primary vat-modal__button';
    businessButton.textContent = strings.businessButton || 'Firma';
    businessButton.addEventListener('click', () => onSelect('business'));

    actions.append(privateButton, businessButton);
    panel.append(title, text, actions);
    return panel;
  }

  function showModalIfNeeded() {
    if (hasStoredSegment()) return;

    const supportsDialog = typeof HTMLDialogElement === 'function' &&
      typeof HTMLDialogElement.prototype.showModal === 'function';

    let container;
    const onSelect = (segment) => {
      setSegment(segment, { source: 'modal', forceRebook: true });
      track('vat_segment_selected', { segment: normalizeSegment(segment), source: 'modal' });
      if (supportsDialog) {
        try {
          container.close();
        } catch (error) {
          // close() fehlt in sehr alten Browsern, remove() unten reicht.
        }
      }
      container.remove();
    };

    if (supportsDialog) {
      const dialog = document.createElement('dialog');
      dialog.className = 'vat-modal';
      dialog.setAttribute('aria-labelledby', 'VatCustomerModalTitle');
      dialog.append(buildModalContent(onSelect));

      // Pflichtauswahl: ESC bzw. Close-Gesten schliessen das Modal nicht ohne Wahl.
      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
      });
      dialog.addEventListener('close', () => {
        if (!hasStoredSegment() && dialog.isConnected) {
          window.setTimeout(() => {
            if (!hasStoredSegment() && dialog.isConnected) dialog.showModal();
          }, 0);
        }
      });

      container = dialog;
      document.body.append(dialog);
      dialog.showModal();
    } else {
      const overlay = document.createElement('div');
      overlay.className = 'vat-modal-overlay';

      const fallback = document.createElement('div');
      fallback.className = 'vat-modal vat-modal--fallback';
      fallback.setAttribute('role', 'dialog');
      fallback.setAttribute('aria-modal', 'true');
      fallback.setAttribute('aria-labelledby', 'VatCustomerModalTitle');
      fallback.append(buildModalContent(onSelect));

      overlay.append(fallback);
      container = overlay;
      document.body.append(overlay);

      const firstButton = fallback.querySelector('button');
      if (firstButton) firstButton.focus();
    }
  }

  function observeDynamicContent() {
    const observer = new MutationObserver((mutations) => {
      const shouldApply = mutations.some((mutation) => {
        return Array.from(mutation.addedNodes).some((node) => {
          if (!(node instanceof HTMLElement)) return false;
          return node.matches('[data-product-card], [data-cart-item]') ||
            Boolean(node.querySelector('[data-product-card], [data-cart-item]'));
        });
      });

      if (shouldApply) {
        window.requestAnimationFrame(() => {
          applySegment(getSegment());
        });
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function getItemKundengruppe(item) {
    const properties = item?.properties || {};
    const storedSegment = properties._vat_segment || properties['_vat_segment'];
    if (storedSegment) return storedSegment;

    const variantTitle = item?.variant_title || '';
    if (segmentFromKundengruppeValue(variantTitle)) {
      return variantTitle;
    }

    return '';
  }

  function cartHasMismatch(items) {
    const segment = getSegment();
    return Array.isArray(items) && items.some((item) => {
      const lineSegment = item?.properties?._vat_segment || item?.properties?.['_vat_segment'];
      if (lineSegment) {
        return lineSegment !== segment;
      }

      const variantTitle = item?.variant_title || '';
      return variantTitle && !kundengruppeValueMatchesSegment(variantTitle, segment);
    });
  }

  function getCartWarningMarkup(items) {
    if (!cartHasMismatch(items)) return '';

    return `
      <div class="vat-cart-warning" role="status">
        <strong>${escapeHtml(strings.cartWarningTitle || 'Hinweis zur Kundenauswahl')}</strong>
        <p>${escapeHtml(strings.cartWarningText || 'Ihr Warenkorb enthaelt Artikel aus dem anderen Steuerkontext.')}</p>
      </div>
    `;
  }

  function escapeHtml(value) {
    return String(value ?? '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#39;');
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-vat-segment-option]');
    if (!button) return;

    event.preventDefault();
    setSegment(button.dataset.vatSegmentOption, { source: 'switch' });
  });

  document.addEventListener('submit', () => {
    updateFormSegments(getSegment());
  }, true);

  document.addEventListener('cart:updated', () => {
    const seg = getSegment();
    updateCartWarnings(seg);
    highlightCartLineMismatch(seg);
  });

  function initVatFilter() {
    applySegment(getSegment());
    observeDynamicContent();
    showModalIfNeeded();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVatFilter);
  } else {
    initVatFilter();
  }

  window.addEventListener('load', () => {
    applySegment(getSegment());
  });

  // Segmentwechsel aus anderen Tabs uebernehmen (nur UI — die Umbuchung
  // erledigt der Tab, in dem der Wechsel ausgeloest wurde).
  window.addEventListener('storage', (event) => {
    if (event.key !== storageKey) return;
    applySegment(getSegment());
  });

  window.customerVatContext = {
    getSegment,
    getSegmentTag,
    getSegmentMatcher,
    setSegment,
    adoptSegment,
    rebookCartToSegment,
    applySegment,
    resolveVariantForProduct,
    isAlways19Product,
    variantMatchesSegment,
    kundengruppeValueMatchesSegment,
    valueMatchesCustomerSegment,
    getVariantKundengruppeValue,
    segmentFromKundengruppeValue,
    valueMatchesSegment,
    buildProductCatalogForSegment,
    getVatContextPayload,
    updateProductCards,
    formatMoney,
    getCartWarningMarkup,
    highlightCartLineMismatch
  };
})();
